
import UIDonutSvgMask from './UIDonutSvgMask.vue';
import UIDonutSvgOverlay from './UIDonutSvgOverlay.vue';

const COLORS = [
  '#2377FF',
  '#75C600',
  '#D933F8',
  '#FC8F00',
  '#3D9299',
  '#C8CAB9',
];

const isSafari =
  typeof window !== 'undefined' &&
  /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
export default {
  name: 'UIDonutChart',
  components: {
    UIDonutSvgMask,
    UIDonutSvgOverlay,
  },
  props: {
    chartData: {
      type: Array,
      required: true,
    },
    chartSize: {
      type: Number,
      default: 64,
    },
  },
  computed: {
    isSafari() {
      return isSafari;
    },
    processedChartData() {
      const sorted = [...this.chartData].sort((a, b) => b.value - a.value);

      const top5 = sorted.slice(0, 5);
      const rest = sorted.slice(5);

      const othersValue = rest.reduce((sum, item) => sum + item.value, 0);

      const finalData = [...top5];

      if (othersValue > 0) {
        finalData.push({
          name: 'Others',
          value: Number(othersValue.toFixed(2)),
        });
      }

      return this.normalizeChartData(finalData);
    },
    chartSlices() {
      const itemCount = this.processedChartData.length;

      return this.processedChartData.map((item, index) => {
        const isOthers = index === itemCount - 1 && itemCount > 5;

        const color = isOthers
          ? COLORS[COLORS.length - 1]
          : COLORS[index % (COLORS.length - 1)];

        return {
          ...item,
          displayName: this.getCompanyName(item.name),
          color,
        };
      });
    },
  },
  methods: {
    getCompanyName(name) {
      if (!name) return '';
      const firstWord = name.split(' ')[0];
      return firstWord.split('.')[0];
    },
    normalizeChartData(data) {
      const sanitized = data.map((item) => ({
        ...item,
        value: Math.max(Number(item.value) || 0, 0),
      }));

      const total = sanitized.reduce((sum, item) => sum + item.value, 0);

      if (total <= 0) {
        return sanitized;
      }

      const normalized = sanitized.map((item) => ({
        ...item,
        value: Number(((item.value / total) * 100).toFixed(2)),
      }));

      const normalizedTotal = normalized.reduce(
        (sum, item) => sum + item.value,
        0
      );
      const delta = Number((100 - normalizedTotal).toFixed(2));

      if (normalized.length > 0 && delta !== 0) {
        normalized[normalized.length - 1].value = Number(
          (normalized[normalized.length - 1].value + delta).toFixed(2)
        );
      }

      return normalized;
    },
  },
};
